import { Box, Tab, Tabs, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AssessmentDetails from './AssessmentDetails';
import AssessmentScoping from './AssessmentScoping';

function AssessmentPlan() {
  const { t } = useTranslation();
  const TabValues = Object.freeze({
    SCOPE: 'scope',
    DETAILS: 'details',
    valueOf(index) {
      switch (index) {
        case 1:
          return TabValues.DETAILS;
        case 0:
        default:
          return TabValues.SCOPE;
      }
    },
    indexOf(value) {
      switch (value) {
        case TabValues.DETAILS:
          return 1;
        case TabValues.SCOPE:
        default:
          return 0;
      }
    },
  });

  const [selectedTab, setSelectedTab] = useState(TabValues.SCOPE);

  const handleChange = (_, index) => {
    setSelectedTab(TabValues.valueOf(index));
  };

  function renderTabContents(tab) {
    switch (tab) {
      case TabValues.DETAILS:
        return <AssessmentDetails />;
      case TabValues.SCOPE: // Intentional fallthrough
      default:
        return <AssessmentScoping />;
    }
  }

  return (
    <Box sx={{ maxWidth: '1200px' }}>
      <Typography variant="body1">
        {`${t('assessment.plan.scopeDescription')} ${t('assessment.plan.detailsDescription')}`}
      </Typography>
      <Tabs variant="fullWidth" sx={{ my: '24px' }} value={TabValues.indexOf(selectedTab)} onChange={handleChange}>
        <Tab id='scope' variant="tab" label={t('assessment.plan.scope')} />
        <Tab id='details' variant="tab" label={t('assessment.plan.details')} />
      </Tabs>
      {renderTabContents(selectedTab)}
    </Box>
  );
}

export default AssessmentPlan;
